import { useCallback, useEffect } from "react"
import { Box } from "@mui/material"
import { NavigationAssistant } from "./Atom"
import { useSelector } from "react-redux"
import { AiHeader } from "../../components/Headers"
import { useMemo } from "react"
import { ProntoAiTable } from "../../components/Table"
import {
  fetchAdvisorList,
  fetchGroupsHandler,
  fetchOfficesHandler,
  fetchProntoAiDataHandler,
  fetchProntoAiTableDataHandler,
  fetchRegionsHandler,
  fetchStoreById,
} from "./apiUtils"
import { getTokenLocal } from "../../../helper/utils"
import { useAppDispatch } from "../../redux/hooks"
import { useNavigate } from "react-router-dom"
import { setLoading, setOpenSidebar } from "../../redux/slices/appSlice"
import {
  setMaevaGroups,
  setMaevaPractices,
  setMaevaRegions,
  setOpportunityAdvisorList,
} from "../../redux/slices/metricSlice"
import {
  setProntoAiColumns,
  setProntoAiData,
  setProntoAiStoreData,
  setProntoAiTableData,
} from "../../redux/slices/prontoAiSlice"
import AiCreateOpportunityModal from "../../components/Modal/AiCreateOpportunityModal"

type ProntoAiProps = {}

const ProntoAi = (props: ProntoAiProps) => {
  //? Essentials
  const token = getTokenLocal()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  dispatch(setOpenSidebar(false))

  const loading = useCallback((loadVal: boolean) => {
    dispatch(setLoading(loadVal))
  }, [])

  const maevaSelectedGroup = useSelector((state: any) => {
    return state.metric.maevaSelectedGroupsNoAll?.[0]
  })
  const maevaSelectedRegion = useSelector((state: any) => {
    return state.metric.maevaSelectedRegions?.[0]
  })
  const maevaSelectedPractice = useSelector((state: any) => {
    return state.metric.maevaSelectedPractices?.[0]
  })
  const selectedMetric = useSelector((state: any) => {
    return state.prontoAi.selectedMetric
  })

  const handleFetchProntoAiTableData = () => {
    if (maevaSelectedGroup) {
      fetchProntoAiTableDataHandler({
        token,
        dispatch: (columns: any, data: any) => {
          dispatch(setProntoAiColumns(columns))
          dispatch(setProntoAiTableData(data))
        },
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
        practice: maevaSelectedPractice,
      })
    }
  }
  const handleFetchStoreById = async () => {
    if (selectedMetric) {
      await fetchStoreById({
        token,
        dispatch: (payload: any) => {
          dispatch(setProntoAiStoreData(payload))
        },
        metric: selectedMetric,
      })
    }
  }

  useEffect(() => {
    fetchGroupsHandler({
      token,
      dispatch: (payload: any) => {
        dispatch(setMaevaGroups(payload))
      },
      navigate,
      loading,
    })
  }, [])

  useEffect(() => {
    if (maevaSelectedGroup) {
      fetchRegionsHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaRegions(payload))
        },
        navigate,
        group: maevaSelectedGroup,
        loading,
      })
    }
  }, [maevaSelectedGroup])

  useEffect(() => {
    if (maevaSelectedRegion) {
      fetchOfficesHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaPractices(payload))
        },
        navigate,
        loading,
        group: maevaSelectedGroup,
        region: maevaSelectedRegion,
      })
    }
  }, [maevaSelectedRegion])

  useEffect(() => {
    if (maevaSelectedGroup) {
      fetchAdvisorList({
        token,
        dispatch: (payload: any) => {
          dispatch(setOpportunityAdvisorList(payload))
        },
        group: maevaSelectedGroup,
        loading,
      })
    }
  }, [maevaSelectedGroup])

  useEffect(() => {
    handleFetchProntoAiTableData()
  }, [maevaSelectedGroup, maevaSelectedRegion, maevaSelectedPractice])

  useEffect(() => {
    if (selectedMetric) {
      fetchProntoAiDataHandler({
        token,
        navigate,
        dispatch: (payload: any) => {
          dispatch(setProntoAiData(payload))
        },
        metric: selectedMetric,
      })
    }
  }, [selectedMetric])

  useEffect(() => {
    handleFetchStoreById()
  }, [selectedMetric])

  const navigationData = useMemo(
    () => [
      {
        label: "Select a group to proceed",
        value: maevaSelectedGroup ? true : false,
      },
      {
        label: "Select a region to proceed",
        value: maevaSelectedRegion ? true : false,
      },
      {
        label: "Select an office to proceed",
        value: maevaSelectedPractice ? true : false,
      },
    ],
    [
      maevaSelectedGroup,
      maevaSelectedRegion,
      maevaSelectedPractice,
      //   selectedProvider,
    ],
  )

  return (
    <>
      <Box
        sx={{
          // border: "1px solid red",
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          height: "100%",
          backgroundColor: "#F8F9FA",
        }}
      >
        <AiHeader name="Pronto AI" />
        {maevaSelectedPractice ? (
          <Box sx={{ padding: "0 20px" }}>
            <ProntoAiTable handleFetchStoreById={handleFetchStoreById} />
          </Box>
        ) : (
          <NavigationAssistant data={navigationData} />
        )}
      </Box>
      <AiCreateOpportunityModal
        handleFetchProntoAiTableData={handleFetchProntoAiTableData}
      />
    </>
  )
}

export default ProntoAi
